import { reactive } from 'vue'
import type {
  CopilotProjectContext,
  CopilotContextItem,
  CopilotTemplate,
  GeneratedDocument,
} from '@/types'

export interface CopilotState {
  // Project context
  selectedProjectId: string | null
  projectContext: CopilotProjectContext | null
  contextItems: CopilotContextItem[]
  selectedItemIds: string[]

  // Context loading
  isLoadingContext: boolean
  isExtractingContent: boolean

  // Templates
  activeTemplate: CopilotTemplate | null

  // Generated output
  generatedDocument: GeneratedDocument | null

  // Session management
  currentSessionId: string | null

  // UI state
  error: string | null
}

export const getInitialState = (): CopilotState => ({
  selectedProjectId: null,
  projectContext: null,
  contextItems: [],
  selectedItemIds: [],
  isLoadingContext: false,
  isExtractingContent: false,
  activeTemplate: null,
  generatedDocument: null,
  currentSessionId: null,
  error: null,
})

export const createState = (): CopilotState => {
  return reactive(getInitialState())
}

export const resetState = (state: CopilotState): void => {
  const initial = getInitialState()
  state.selectedProjectId = initial.selectedProjectId
  state.projectContext = initial.projectContext
  state.contextItems = initial.contextItems
  state.selectedItemIds = initial.selectedItemIds
  state.isLoadingContext = initial.isLoadingContext
  state.isExtractingContent = initial.isExtractingContent
  state.activeTemplate = initial.activeTemplate
  state.generatedDocument = initial.generatedDocument
  state.currentSessionId = initial.currentSessionId
  state.error = initial.error
}
